import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "./firebaseConfig";
import dayjs from "dayjs";

const AdminLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(20);
  const [showAll, setShowAll] = useState(false);


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const uid = searchParams.get("uid");

  const [categoryFilter, setCategoryFilter] = useState("");

  const actionCategoryMap = {
    "Logged in": "Authentication",
    "Reset User Password": "Authentication",
    "Created Order": "Orders",
    "Viewed Sales Report": "Reports",
    "Updated User Role": "Admin",
    "Deleted User": "Admin",
    "Searched Order": "Search",
    "Searched Orders by Date": "Search",
    "Updated Inventory": "Inventory",
    "Restocked Cookies": "Inventory",
    "Transferred Inventory": "Inventory"
  };

  const filteredLogs = logs.filter(log =>
    !categoryFilter || actionCategoryMap[log.action] === categoryFilter
  );


  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      setError(null);

      if (!uid) {
        setError("No user ID provided.");
        setLoading(false);
        return;
      }

      try {
        const logsRef = collection(db, "activityLogs");
        const q = query(
          logsRef,
          where("userId", "==", uid),
          orderBy("timestamp", "desc")
        );
        const snapshot = await getDocs(q);

        const logData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setLogs(logData);
      } catch (err) {
        console.error("Error fetching logs:", err);
        setError("Failed to load logs.");
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [uid]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Activity Logs</h1>

      {loading && <p>Loading logs...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && logs.length === 0 && <p>No logs found for this user.</p>}

      <select
        value={categoryFilter}
        onChange={(e) => setCategoryFilter(e.target.value)}
        className="border px-3 py-2 rounded w-full md:w-1/4"
      >
        <option value="">All Categories</option>
        <option value="Authentication">Authentication</option>
        <option value="Orders">Orders</option>
        <option value="Search">Search</option>
        <option value="Reports">Reports</option>
        <option value="Admin">Admin</option>
        <option value="Inventory">Inventory</option>
      </select>

      <div className="space-y-4">
        {filteredLogs.slice(0, showAll ? filteredLogs.length : visibleCount).map((log) => (
          <div key={log.id} className="border p-4 rounded bg-white shadow">
            <div className="text-sm text-gray-500">
              <div className="text-sm text-gray-500">
                Performed by: {log.userEmail}
              </div>
              {log.timestamp?.toDate
                ? dayjs(log.timestamp.toDate()).format("MMM D, YYYY h:mm A")
                : "No timestamp"}
            </div>
            <div className="text-lg font-semibold">{log.action}</div>
            {log.details && (
              <pre className="mt-2 text-sm bg-gray-100 p-2 rounded overflow-x-auto">
                {JSON.stringify(log.details, null, 2)}
              </pre>
            )}
          </div>
        ))}
        {filteredLogs.length > visibleCount && !showAll && (
          <div className="mt-6 text-center">
            <button
              onClick={() => setVisibleCount(visibleCount + 20)}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mr-3"
            >
              Load More
            </button>
            <button
              onClick={() => setShowAll(true)}
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
            >
              Load All
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLogsPage;
